export default {
    title: 'Strategic vision',
    description:
        "Define your organization's strategic vision that will guide all objectives and initiatives.",
    placeholder: "Enter your organization's strategic vision...",
    save: 'Save',
    visionLabel: 'Vision',
    saveSuccess: 'Strategic vision saved.',
    maxLength: 'The vision must not exceed {{max}} characters.',
    referenceLanguage: 'Reference language: {{language}}',
    errorLoadingStrategicVision: 'Error loading the strategic vision',
};
